module.exports = __webpack_public_path__ + "static/media/india-avenue-i.f7b2a5ea.csv";